// eslint-disable-next-line import/prefer-default-export
export const authenticationTypes = {
  SIGN_UP: 'SIGN_UP',
};
